import { render } from "./MenuOffer.vue?vue&type=template&id=c971ceec"
import script from "./MenuOffer.vue?vue&type=script&lang=js"
export * from "./MenuOffer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/MenuOffer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c971ceec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c971ceec', __exports__)) {
    api.reload('c971ceec', __exports__)
  }
  
  module.hot.accept("./MenuOffer.vue?vue&type=template&id=c971ceec", () => {
    api.rerender('c971ceec', render)
  })

}


export default __exports__